import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { crearProducto } from 'scripts/crearProducto';
import { actualizarProducto } from 'scripts/actualizarProducto';
import { borrarProducto } from 'scripts/borrarProducto';
import { asociarProductoDescuento } from 'scripts/asociarProductoDescuento';
import { asociarProductoAdicional } from 'scripts/asociarProductoAdicional';
import { obtenerTodosProductosAdmin } from 'scripts/obtenerTodosProductosAdmin';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Button,
	Paper,
	TextField,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Box,
	Grid,
	InputAdornment,
	FormControlLabel,
	Checkbox,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { subirImagenConThumbnails } from 'scripts/firebaseUpload';
import { obtenerTodosAdicionales } from 'scripts/obtenerTodosAdicionales';
import { obtenerDescuentos } from 'scripts/obtenerDescuentos';
import { mostrarValorDescuento } from 'utils/descuentosUtils';
import { toast } from 'react-toastify';
import CustomDialog from 'helpers/Dialog';
import { quitarProductoDescuento } from 'scripts/quitarProductoDescuento';
import { quitarProductoAdicional } from 'scripts/quitarProductoAdicional';

const ProductManagement = () => {
	const dispatch = useDispatch();
	const [descuentosSeleccionados, setDescuentosSeleccionados] = useState([]);
	const [adicionalesSeleccionados, setAdicionalesSeleccionados] = useState([]);
	const productos = useSelector((state) => state.productos);
	const categorias = useSelector((state) => state.categorias);
	const adicionales = useSelector((state) => state.gestionAdicionales || []);
	const descuentos = useSelector((state) => state.descuentos || []);
	const [searchTerm, setSearchTerm] = useState('');
	const [selectedCategory, setSelectedCategory] = useState('');
	const [minPrice, setMinPrice] = useState('');
	const [maxPrice, setMaxPrice] = useState('');
	const [searchDescuentos, setSearchDescuentos] = useState('');
	const [open, setOpen] = useState(false);
	const [descuentoCategoria, setDescuentoCategoria] = useState(null);
	const [newProduct, setNewProduct] = useState({
		id: null,
		titulo: '',
		descripcion: '',
		precio: '',
		categoria: { id: '' },
		visible: true,
		adicionales: [],
	});

	const fetchProductos = async () => {
		await obtenerTodosProductosAdmin(dispatch);
	};
	const fetchAdicionales = async () => {
		await obtenerTodosAdicionales(dispatch, sessionStorage.getItem('token'));
	};
	const fetchDescuentos = async () => {
		await obtenerDescuentos(dispatch, sessionStorage.getItem('token'));
	};

	useEffect(() => {
		try {
			fetchProductos();
			fetchAdicionales();
			fetchDescuentos();
		} catch (e) {
			console.log(e);
		}
	}, [dispatch]);

	const [searchAdicionales, setSearchAdicionales] = useState('');

	const filteredAdicionales = adicionales.filter((adicional) =>
		adicional.descripcion.toLowerCase().includes(searchAdicionales.toLowerCase()),
	);

	const filteredProducts = productos.filter((product) => {
		const matchesSearchTerm = product.titulo.toLowerCase().includes(searchTerm.toLowerCase());
		const matchesCategory = selectedCategory
			? product.categoria?.titulo?.toLowerCase().includes(selectedCategory.toLowerCase())
			: true;
		const matchesMinPrice = minPrice ? product.precio >= minPrice : true;
		const matchesMaxPrice = maxPrice ? product.precio <= maxPrice : true;

		return matchesSearchTerm && matchesCategory && matchesMinPrice && matchesMaxPrice;
	});

	const filteredDescuentos = descuentos.filter((descuento) =>
		descuento.descripcion.toLowerCase().includes(searchDescuentos.toLowerCase()),
	);

	const filteredDescuentoCategoria = descuentos.filter((descuento) => descuento.id === descuentoCategoria);

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setNewProduct((prevState) => ({
				...prevState,
				imagen: file,
			}));
		}
	};

	const handleDescuentoChange = (id) => {
		if (descuentosSeleccionados.includes(id)) {
			setDescuentosSeleccionados((prev) => prev.filter((descuentoId) => descuentoId !== id));
		} else {
			setDescuentosSeleccionados((prev) => [...prev, id]);
		}
	};

	const handleAdicionalChange = (id) => {
		if (adicionalesSeleccionados.includes(id)) {
			setAdicionalesSeleccionados((prev) => prev.filter((adicionalId) => adicionalId !== id));
		} else {
			setAdicionalesSeleccionados((prev) => [...prev, id]);
		}
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setNewProduct({ ...newProduct, [name]: value });
	};

	const handleCategoryChange = (e) => {
		const selectedCategory = categorias.find((categoria) => categoria.id === parseInt(e.target.value));
		if (selectedCategory.descuentos.length > 0 && selectedCategory.descuentos[0].referencia === 'categoria') {
			setDescuentosSeleccionados([selectedCategory.descuentos[0].descuento_id]);
			setDescuentoCategoria(selectedCategory.descuentos[0].descuento_id);
		} else {
			setDescuentosSeleccionados(
				newProduct.descuentos
					.filter((desc) => desc.referencia === 'producto')
					.map((descuento) => descuento.descuento_id),
			);
			setDescuentoCategoria(null);
		}
		setNewProduct({ ...newProduct, categoria: selectedCategory });
	};

	const handleOpen = (product = null) => {
		if (product) {
			setNewProduct({ ...product });
		} else {
			setNewProduct({
				id: null,
				titulo: '',
				descripcion: '',
				precio: '',
				categoria: { id: '' },
				adicionales: [],
				descuentos: [],
				visible: 'true',
			});
		}
		if (product && Array.isArray(product.adicionales)) {
			const idsAdicionales = product.adicionales.map((adicional) => adicional.id);
			setAdicionalesSeleccionados(idsAdicionales);
		} else {
			setAdicionalesSeleccionados([]);
		}
		if (product && product.descuentos.length > 0 && product.descuentos[0].referencia === 'categoria') {
			setDescuentoCategoria(product.descuentos[0].descuento_id);
		} else {
			if (product && Array.isArray(product.descuentos)) {
				const idsDescuentos = product.descuentos.map((descuento) => descuento.descuento_id);
				setDescuentosSeleccionados(idsDescuentos);
			} else {
				setDescuentosSeleccionados([]);
			}
		}
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const [dialogOpen, setDialogOpen] = useState(false);
	const [id, setId] = useState(null);

	const handleOpenDialog = (id) => {
		setId(id);
		setDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setId(null);
		setDialogOpen(false);
	};

	const handleConfirmDialog = () => {
		borrarProducto(id, sessionStorage.getItem('token'))
			.then((data) => {
				toast.success('Producto eliminado correctamente.');
				fetchProductos();
			})
			.catch((error) => {
				toast.error('Error al eliminar el producto.');
			});
		setDialogOpen(false);
	};

	const handleSaveProduct = async () => {
		if (newProduct.titulo && newProduct.descripcion && newProduct.precio && newProduct.categoria) {
			try {
				let imageUrl = newProduct.imagen === null ? '' : newProduct.imagen;
				let thumbnailUrl = newProduct.imagen_thumbnail || '';
				let fullUrl = newProduct.imagen_full || '';
				let productId = newProduct.id;

				// Si hay un nuevo archivo seleccionado, procesarlo y subirlo a Firebase
				if (
					newProduct.imagen !== null &&
					newProduct.imagen !== undefined &&
					typeof newProduct.imagen !== 'string'
				) {
					toast.info('Procesando imagen y generando thumbnails...');
					try {
						const imageUrls = await subirImagenConThumbnails(newProduct.imagen);
						imageUrl = imageUrls.original;
						thumbnailUrl = imageUrls.thumbnail;
						fullUrl = imageUrls.full;
						toast.success('Imagen procesada exitosamente');
					} catch (error) {
						toast.error('Error al procesar la imagen: ' + error.message);
						return;
					}
				}

				const productoData = {
					titulo: newProduct.titulo,
					descripcion: newProduct.descripcion,
					precio: newProduct.precio,
					categoria_id: newProduct.categoria.id,
					visible: newProduct.visible,
					imagen: imageUrl,
					imagen_thumbnail: thumbnailUrl,
					imagen_full: fullUrl,
				};

				if (newProduct.id === null) {
					const productoCreado = await crearProducto(productoData, sessionStorage.getItem('token'));
					if (productoCreado && productoCreado.id) {
						fetchProductos();
						productId = productoCreado.id;
						toast.success('Producto creado.');
					} else {
						toast.error('Error al crear el producto en la base de datos.');
					}
				} else {
					actualizarProducto(newProduct.id, productoData, sessionStorage.getItem('token'))
						.then(() => {
							toast.success('Producto actualizado.');
							fetchProductos();
						})
						.catch(() => {
							toast.error('Error al actualizar el producto.');
						});
				}
				let descuentosARemover = [];
				if (descuentoCategoria) {
					descuentosARemover = newProduct.descuentos.filter((desc) => desc.referencia === 'producto');
				} else {
					// Asociar los descuentos seleccionados
					if (descuentosSeleccionados.length > 0) {
						const productId = newProduct.id;
						for (let i = 0; i < descuentosSeleccionados.length; i++) {
							try {
								asociarProductoDescuento(
									descuentosSeleccionados[i],
									productId,
									sessionStorage.getItem('token'),
								)
									.then(() => {
										toast.success('Descuento asociado al producto.');
									})
									.catch((error) => {
										console.log('Error al asociar el descuento al producto.' + error.message);
									});
							} catch (error) {
								console.log('Error al asociar el descuento al producto.' + error.message);
								break; // Salir del bucle si ocurre un error
							}
						}
					}
					// Remove discounts that are not selected anymore
					descuentosARemover = newProduct.descuentos.filter(
						(descuento) =>
							!descuentosSeleccionados.includes(descuento.descuento_id) &&
							descuento.referencia === 'producto',
					);
				}

				for (let i = 0; i < descuentosARemover.length; i++) {
					try {
						await quitarProductoDescuento(
							descuentosARemover[i].descuento_id,
							newProduct.id,
							sessionStorage.getItem('token'),
						);
						toast.success('Descuento removido del producto.');
					} catch (error) {
						toast.error('Error al remover el descuento del producto.');
						break; // Exit the loop if an error occurs
					}
				}

				const adicionalesARemover = newProduct.adicionales.filter(
					(adicional) => !adicionalesSeleccionados.includes(adicional.id),
				);
				for (let i = 0; i < adicionalesARemover.length; i++) {
					try {
						await quitarProductoAdicional(
							adicionalesARemover[i].id,
							newProduct.id,
							sessionStorage.getItem('token'),
						);
						toast.success('Adicional removido del producto.');
					} catch (error) {
						toast.error('Error al remover el adicional del producto.');
						break; // Exit the loop if an error occurs
					}
				}
				const adicionalesProducto = newProduct.adicionales.map((adicional) => adicional.id);
				const adicionalesACrear = adicionalesSeleccionados.filter(
					(adicionalId) => !adicionalesProducto.includes(adicionalId),
				);
				// Asociar los adicionales seleccionados
				if (adicionalesACrear.length > 0) {
					for (let i = 0; i < adicionalesACrear.length; i++) {
						try {
							await asociarProductoAdicional(
								adicionalesACrear[i],
								productId,
								sessionStorage.getItem('token'),
							);
							toast.success('Adicional asociado al producto.');
						} catch (error) {
							toast.error('Error al asociar el adicional al producto.');
							break; // Salir del bucle si ocurre un error
						}
					}
				}

				// Resetear el formulario
				setNewProduct({
					titulo: '',
					descripcion: '',
					precio: '',
					categoria: '',
					visible: true,
					imagen: '',
				});

				handleClose();
			} catch (error) {
				toast.error('Error al procesar el producto.');
			}
		} else {
			toast.error('Por favor, complete todos los campos.');
		}
	};

	return (
		<div style={{ marginTop: '20px' }}>
			{/* Filtros y búsqueda */}
			<Box
				sx={{
					marginBottom: 2,
					paddingBottom: 2,
					borderBottom: '2px solid #ccc',
					position: 'relative',
				}}
			>
				<Grid container spacing={2} alignItems="center">
					<Grid item xs={12} sm={2} md={1} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
						<Button variant="contained" color="success" onClick={() => handleOpen()}>
							<AddIcon />
						</Button>
					</Grid>
					{/* Barra de búsqueda por descripción */}
					<Grid item xs={12} sm={6} md={3}>
						<TextField
							label="Buscar por descripción"
							variant="outlined"
							fullWidth
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
							}}
						/>
					</Grid>
					{/* Buscador por categoría */}
					<Grid item xs={12} sm={4} md={3}>
						<TextField
							label="Buscar por categoría"
							variant="outlined"
							value={selectedCategory}
							onChange={(e) => setSelectedCategory(e.target.value)}
							fullWidth
						/>
					</Grid>
					{/* Filtros de precios */}
					<Grid item xs={12} sm={3} md={2}>
						<TextField
							label="Precio mínimo"
							type="number"
							variant="outlined"
							value={minPrice}
							onChange={(e) => setMinPrice(e.target.value)}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={3} md={2}>
						<TextField
							label="Precio máximo"
							type="number"
							variant="outlined"
							value={maxPrice}
							onChange={(e) => setMaxPrice(e.target.value)}
							fullWidth
						/>
					</Grid>
				</Grid>
			</Box>

			{/* Tabla de productos */}
			<TableContainer component={Paper} sx={{ maxHeight: 400, overflowY: 'auto' }}>
				<Table>
					<TableHead
						sx={{
							position: 'sticky',
							top: 0,
							backgroundColor: '#FFFFFF',
							zIndex: 1,
						}}
					>
						<TableRow>
							<TableCell>Titulo</TableCell>
							<TableCell>Descripción</TableCell>
							<TableCell>Precio</TableCell>
							<TableCell>Categoría</TableCell>
							<TableCell>Visible</TableCell>
							<TableCell>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredProducts.length > 0 ? (
							filteredProducts.map((product) => (
								<TableRow key={product.id}>
									<TableCell>{product.titulo}</TableCell>
									<TableCell>{product.descripcion}</TableCell>
									<TableCell>{product.precio}</TableCell>
									<TableCell>{product.categoria?.titulo}</TableCell>
									<TableCell>{product.visible ? 'Sí' : 'No'}</TableCell>
									<TableCell>
										<Button
											variant="outlined"
											sx={{ marginRight: 2 }}
											color="primary"
											onClick={() => handleOpen(product)}
										>
											Editar
										</Button>
										<Button
											variant="outlined"
											color="secondary"
											onClick={() => handleOpenDialog(product.id)}
										>
											Eliminar
										</Button>
									</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={5} style={{ textAlign: 'center' }}>
									No hay productos disponibles.
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>

			{/* Diálogo para agregar/editar producto */}
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>{newProduct.id ? 'Editar Producto' : 'Nuevo Producto'}</DialogTitle>
				<DialogContent>
					{/* Descripción */}
					Titulo
					<TextField
						name="titulo"
						variant="outlined"
						value={newProduct.titulo}
						onChange={handleInputChange}
						fullWidth
						style={{ marginBottom: '10px' }}
					/>
					Descripción
					<TextField
						name="descripcion"
						variant="outlined"
						value={newProduct.descripcion}
						onChange={handleInputChange}
						fullWidth
						multiline
						rows={4}
						maxRows={10} // Permite expansión hasta 10 líneas
						style={{ marginBottom: '10px' }}
					/>
					{/* Precio */}
					Precio
					<TextField
						name="precio"
						variant="outlined"
						value={newProduct.precio}
						onChange={handleInputChange}
						fullWidth
						type="number"
						style={{ marginBottom: '10px' }}
					/>
					{/* Categoría */}
					Categoría
					<TextField
						name="categoria"
						variant="outlined"
						value={newProduct.categoria.id}
						onChange={handleCategoryChange}
						fullWidth
						select
						SelectProps={{
							native: true,
						}}
						style={{ marginBottom: '10px' }}
					>
						<option value="">Seleccionar categoría</option>
						{categorias.map((categoria) => (
							<option key={categoria.id} value={categoria.id}>
								{categoria.titulo}
							</option>
						))}
					</TextField>
					{/* Lista de adicionales: Solo disponible en caso de actualizar producto */}
					Adicionales
					<Box style={{ marginTop: '10px', marginBottom: '10px' }}>
						<TextField
							variant="outlined"
							fullWidth
							placeholder="Buscar adicionales..."
							onChange={(e) => setSearchAdicionales(e.target.value)}
							value={searchAdicionales}
							style={{ marginBottom: '10px' }}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
							}}
						/>
						<Box
							style={{
								border: '1px solid #ccc',
								borderRadius: '8px',
								padding: '10px',
								maxHeight: '200px',
								overflowY: 'auto',
								backgroundColor: '#f9f9f9',
							}}
						>
							{filteredAdicionales.length > 0 ? (
								filteredAdicionales.map((adicional) => (
									<Box
										key={adicional.id}
										style={{
											display: 'flex',
											alignItems: 'center',
											marginBottom: '5px',
											padding: '5px',
											borderBottom: '1px solid #e0e0e0',
										}}
									>
										<FormControlLabel
											control={
												<Checkbox
													checked={adicionalesSeleccionados.includes(adicional.id)}
													onChange={() => handleAdicionalChange(adicional.id)}
													color="primary"
												/>
											}
											label={adicional.descripcion}
										/>
									</Box>
								))
							) : (
								<p style={{ textAlign: 'center', color: '#888' }}>No hay adicionales disponibles.</p>
							)}
						</Box>
					</Box>
					{/* Lista de descuentos: Solo disponible en caso de actualizar producto  */}
					Descuentos
					{descuentoCategoria ? (
						<Box
							style={{
								border: '1px solid #ccc',
								borderRadius: '8px',
								padding: '10px',
								maxHeight: '200px',
								overflowY: 'auto',
								backgroundColor: '#f9f9f9',
							}}
						>
							{filteredDescuentoCategoria.length > 0 ? (
								filteredDescuentoCategoria.map((descuento) => (
									<Box
										key={descuento.id}
										style={{
											display: 'flex',
											alignItems: 'center',
											marginBottom: '5px',
											padding: '5px',
											borderBottom: '1px solid #e0e0e0',
										}}
									>
										<FormControlLabel
											control={
												<Checkbox
													checked={true}
													onChange={() => handleDescuentoChange(descuento.id)}
													color="primary"
													disabled={true}
												/>
											}
											label={`${descuento.descripcion} - (Valor: ${mostrarValorDescuento(
												descuento.valor,
												descuento.tipo,
											)}) - CATEGORIA`}
										/>
									</Box>
								))
							) : (
								<p style={{ textAlign: 'center', color: '#888' }}>No hay descuentos disponibles.</p>
							)}
						</Box>
					) : (
						<Box style={{ marginTop: '10px', marginBottom: '10px' }}>
							<TextField
								variant="outlined"
								fullWidth
								placeholder="Buscar descuentos..."
								onChange={(e) => setSearchDescuentos(e.target.value)}
								value={searchDescuentos}
								style={{ marginBottom: '10px' }}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon />
										</InputAdornment>
									),
								}}
							/>
							<Box
								style={{
									border: '1px solid #ccc',
									borderRadius: '8px',
									padding: '10px',
									maxHeight: '200px',
									overflowY: 'auto',
									backgroundColor: '#f9f9f9',
								}}
							>
								{filteredDescuentos.length > 0 ? (
									filteredDescuentos.map((descuento) => (
										<Box
											key={descuento.id}
											style={{
												display: 'flex',
												alignItems: 'center',
												marginBottom: '5px',
												padding: '5px',
												borderBottom: '1px solid #e0e0e0',
											}}
										>
											<FormControlLabel
												control={
													<Checkbox
														checked={descuentosSeleccionados.includes(descuento.id)}
														onChange={() => handleDescuentoChange(descuento.id)}
														color="primary"
													/>
												}
												label={`${descuento.descripcion} - (Valor: ${mostrarValorDescuento(
													descuento.valor,
													descuento.tipo,
												)})`}
											/>
										</Box>
									))
								) : (
									<p style={{ textAlign: 'center', color: '#888' }}>No hay descuentos disponibles.</p>
								)}
							</Box>
						</Box>
					)}
					{/* Imagen */}
					Imagen
					<input
						type="file"
						accept="image/*"
						onChange={handleImageChange}
						style={{ marginBottom: '10px', display: 'block' }}
					/>
					{/* Visible */}
					<FormControlLabel
						control={
							<Checkbox
								checked={newProduct.visible}
								onChange={(e) => setNewProduct({ ...newProduct, visible: e.target.checked })}
								color="primary"
							/>
						}
						label="Visible"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="secondary">
						Cancelar
					</Button>
					<Button onClick={handleSaveProduct} color="primary">
						{newProduct.id ? 'Guardar cambios' : 'Agregar producto'}
					</Button>
				</DialogActions>
			</Dialog>
			<CustomDialog
				open={dialogOpen}
				title="Confirmar eliminación"
				content="¿Está seguro de que desea eliminar este producto?"
				onClose={handleCloseDialog}
				onConfirm={handleConfirmDialog}
			/>
		</div>
	);
};

export default ProductManagement;
